export const SITE_URL = "driverquiz.taximaximapp.ru";
export const GO_URL = "https://forms.gle/GsjjP9CKgYpWm8BS8";
